import { render, staticRenderFns } from "./DepositoParaCheckear.vue?vue&type=template&id=489bc10f&"
import script from "./DepositoParaCheckear.vue?vue&type=script&lang=js&"
export * from "./DepositoParaCheckear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports